import { faUserTag, faKey, faUsers, faLock } from '@fortawesome/free-solid-svg-icons';
import { headerNames } from './constants';

const parentPath = '/hq-access';

export const hqAdministrationRoutes = {
  hqAccess: {
    path: parentPath,
    key: 'hq-access',
    value: headerNames?.hqAccess,
    icon: faLock,
    QADataTag: 'adminPortalNav',
  },
  adminUsers: {
    path: `${parentPath}?t=admin-users`,
    key: 'hq-admin-admin-users',
    value: 'Admins',
    icon: faUsers,
    QADataTag: 'adminUsersNav',
    permission: 'membership.members.admin.view',
  },
  roles: {
    path: `${parentPath}?t=roles`,
    key: 'hq-admin-roles',
    value: 'Roles',
    icon: faUserTag,
    QADataTag: 'rolesNav',
    permission: 'membership.roles.view',
  },
  permissions: {
    path: `${parentPath}?t=permissions`,
    key: 'hq-admin-permissions',
    value: 'Permissions',
    icon: faKey,
    QADataTag: 'permissionsNav',
    permission: 'membership.permissions.view',
  },
  adminPortalNotFound: {
    path: `${parentPath}/404`,
    key: 'not-found',
    value: 'Not found',
    icon: 'not-found',
  },
};
